import moment from "moment-timezone";
moment.locale("en-us");

/**
 *  weekday abbrs, based on locale
 */
export const DAYS_OF_WEEK = moment.weekdaysShort();

/**
 * weekday abbrs min, based on locale
 * ["sun", "mon", ...]
 */
export const DAYS_OF_WEEK_LOWERCASE_LENGTH_3 = DAYS_OF_WEEK.map((el) =>
  el.slice(0, 3).toLowerCase(),
);

/**
 *  weekday long name, based on locale
 */
export const DAYS_OF_WEEK_LONG = moment.weekdays();
